import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import '@/styles/mobile-calendar-fix.css';
// Private admin only: every rule inside is scoped to [data-admin-theme].
// Loaded last so it wins over the older admin light-theme overrides.
import '@/styles/admin-premium.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
